const updates = [
  { date: '2026.07.29', tag: '更新', title: '《咒术回战》第268话更新上线', desc: '最终决战篇高潮持续，宿傩与虎杖的宿命对决进入白热化阶段' },
  { date: '2026.07.28', tag: '新番', title: '《葬送的芙莉莲》第二季确认制作', desc: '官方宣布续作企划启动，预计2027年播出，粉丝期待值拉满' },
  { date: '2026.07.27', tag: '国漫', title: '《斗破苍穹》年番突破500话', desc: '萧炎中州篇持续热播，国漫之光再创里程碑式更新纪录' },
  { date: '2026.07.26', tag: '热门', title: '《我推的孩子》第三季先行PV公开', desc: '新篇章舞台剧篇即将开幕，声优阵容与制作班底全面升级' },
  { date: '2026.07.25', tag: '韩漫', title: '《我独自升级》特别篇上线', desc: '韩漫改编动画人气爆棚，特别篇补充主线之外的精彩支线剧情' },
  { date: '2026.07.24', tag: '更新', title: '《海贼王》艾尔巴夫篇持续连载', desc: '路飞与巨人族的冒险正式展开，新世界的秘密逐步揭晓' },
  { date: '2026.07.23', tag: '资讯', title: '《鬼灭之刃》无限城篇剧场版定档', desc: '三部曲第一部确认2027年春季上映，制作阵容豪华升级' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新动态快讯</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            追踪动漫圈最新消息，不错过任何一部好番的更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[calc(2rem+5px)] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full font-medium">{item.tag}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}